import ComparisonOperators from "../../consts/DataSourceModule/ComparisonOperators";
import FilterParameterDto from "./FilterParameterDto";
import DataTableFieldParameterDefinitionDto from "./DataTableFieldParameterDefinitionDto";

class FilterParameterVariableDto extends FilterParameterDto {
    // Miroir de la relation FilterParameterVariable -> DataTableFieldParameterDefinition côté back.
    // Id > 0 : référence une définition existante. Id == 0 : à créer (le back dédup par TechnicalName au save).
    DataTableFieldParameterDefinition: DataTableFieldParameterDefinitionDto;

    constructor(id: number, fieldReferenceId: number, operator: ComparisonOperators, technicalName: string, definitionId: number = 0) {
        super(id, fieldReferenceId, operator);
        this.DataTableFieldParameterDefinition = new DataTableFieldParameterDefinitionDto(definitionId, technicalName);
    }

    // Commodité de lecture pour le FilterBuilder / le popup : le TechnicalName vit sur la définition liée.
    get TechnicalName(): string {
        return this.DataTableFieldParameterDefinition.TechnicalName;
    }
}

export default FilterParameterVariableDto;
